import {
  TRADING_STYLE_CHIP,
  TRADING_STYLE_DEFAULT_CHIP,
  formatTradingStyle,
} from "@/lib/trader-format";

interface Props {
  style: string | null | undefined;
  /** Show "—" placeholder when style is missing. Default true. */
  showEmpty?: boolean;
}

/**
 * Trading-style chip used in trader leaderboards (e.g. /pits/{slug}/members,
 * /traders). Colors and label format match the canonical version in
 * UsersGrid.tsx — change there too if anything visual shifts.
 */
export default function TradingStyleChip({ style, showEmpty = true }: Props) {
  if (!style) {
    return showEmpty ? <span className="text-[10px] text-gray-600">—</span> : null;
  }
  const cls = TRADING_STYLE_CHIP[style] || TRADING_STYLE_DEFAULT_CHIP;
  return (
    <span className={`inline-block px-2 py-0.5 rounded-[5px] text-[10px] font-bold whitespace-nowrap ${cls}`}>
      {formatTradingStyle(style)}
    </span>
  );
}
